(() => {
  if (window.Shopify && Shopify.Checkout) return;
  if (window.__INKD_CHAT_WIDGET_LOADED__) return;
  window.__INKD_CHAT_WIDGET_LOADED__ = true;

  // ─── CREDENTIALS ─────────────────────────────────────────────────────────
  const GHL_API_KEY         = "pit-aab8777d-fa46-440f-b9f5-8bc934cce2e5";
  const GHL_LOCATION_ID     = "0LzOK2vmmDWXS3Cq8JNO";
  const SUMMARY_EMAIL       = "maria@inkdstores.com";
  const EMAILJS_SERVICE_ID  = "service_gzzxx3d";
  const EMAILJS_TEMPLATE_ID = "template_9xgu2ey";
  const EMAILJS_PUBLIC_KEY  = "4hE4ao_R5NH8yCMGV";
  // ─────────────────────────────────────────────────────────────────────────

  const config          = window.InkdChatConfig || {};
  const WORKER_BASE     = config.workerBase     || "";
  const BRAND_NAME      = config.brandName      || "Chat";
  const LOGO_URL        = config.logoUrl        || "";
  const MEETING_URL     = config.meetingUrl     || "";
  const AUTO_OPEN_PARAM = config.autoOpenParam  || "chat";
  const AUTO_OPEN_VALUE = config.autoOpenValue  || "open";

  // ─── LOAD EMAILJS DYNAMICALLY ────────────────────────────────────────────
  let emailJSReady = false;

  function loadEmailJS() {
    return new Promise((resolve) => {
      if (window.emailjs) {
        window.emailjs.init(EMAILJS_PUBLIC_KEY);
        emailJSReady = true;
        resolve();
        return;
      }
      const s = document.createElement("script");
      s.src = "https://cdn.jsdelivr.net/npm/@emailjs/browser@3/dist/email.min.js";
      s.onload = () => {
        window.emailjs.init(EMAILJS_PUBLIC_KEY);
        emailJSReady = true;
        resolve();
      };
      s.onerror = () => {
        console.warn("[Inkd Chat] EmailJS failed to load.");
        resolve();
      };
      document.head.appendChild(s);
    });
  }

  // Start loading EmailJS immediately
  loadEmailJS();

  // ─── DOM REFS ─────────────────────────────────────────────────────────────
  const root = document.querySelector("[data-inkd-chat-root]");
  if (!root) return;

  const btn               = root.querySelector("[data-chat-toggle]");
  const $launcherIconWrap = root.querySelector(".inkd-chatbot-launcher-icon");
  const $launcherText     = root.querySelector(".inkd-chatbot-launcher-text");
  const box               = root.querySelector("[data-chat-box]");
  const $viewHome         = root.querySelector('[data-view-panel="home"]');
  const $viewMsgs         = root.querySelector('[data-view-panel="messages"]');
  const $msgs             = root.querySelector("[data-msgs]");
  const $input            = root.querySelector("[data-input]");
  const $send             = root.querySelector("[data-send]");
  const $emoji            = root.querySelector("[data-emoji]");
  const $voice            = root.querySelector("[data-voice]");
  const $close            = root.querySelector("[data-close]");
  const $askCard          = root.querySelector('[data-action="ask"]');
  const $meetingCard      = root.querySelector('[data-action="meeting"]');
  const $tabs             = root.querySelectorAll("[data-tab]");
  const $back             = root.querySelector("[data-back]");
  const $brandName        = root.querySelector("[data-brand-name]");
  const $brandLogo        = root.querySelector("[data-brand-logo]");

  if ($brandName) $brandName.textContent = BRAND_NAME;
  if ($brandLogo) { $brandLogo.src = LOGO_URL; $brandLogo.alt = BRAND_NAME; }

  // ─── STATE ────────────────────────────────────────────────────────────────
  let conversationId      = localStorage.getItem("cf_chat_conversation_id") || "";
  let ws                  = null;
  let lastSince           = 0;
  let pollTimer           = null;
  let loadedHistory       = false;
  let pendingHandoffDivider = false;
  let seenMsgKeys         = new Set();
  let customerName        = localStorage.getItem("cf_chat_customer_name")  || "";
  let customerEmail = localStorage.getItem("cf_chat_customer_email") || "";
  let customerPhone = localStorage.getItem("cf_chat_customer_phone") || "";
  let typingEl            = null;
  let handoffShown        = false;
  let emojiPop            = null;
  let rec                 = null;
  let isRecording         = false;
  let contactCaptured     = localStorage.getItem("cf_chat_contact_captured") === "1";
  let contactCaptureShown = false;
  let conversationLog     = [];
  let emailSummarySent    = false;

  const EMOJIS = ["😀","😄","😅","😂","🥹","😍","🔥","💪","✅","🎉","🙏","🤝","❤️","😎","🚀","📦","📅","📞","🧠","✨"];

  const esc = (s) => (s || "").replace(/[&<>"]/g, (c) =>
    ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c])
  );
  const fmt = (ts) => new Date(ts).toLocaleTimeString();

  // ─── LAUNCHER ────────────────────────────────────────────────────────────
  function launcherChatIcon() {
    return `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>`;
  }
  function launcherCloseIcon() {
    return `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"></path></svg>`;
  }
  function syncLauncherState() {
    const isOpen = box.classList.contains("is-open");
    if ($launcherIconWrap) $launcherIconWrap.innerHTML = isOpen ? launcherCloseIcon() : launcherChatIcon();
    if ($launcherText) {
      $launcherText.textContent  = isOpen ? "" : "Chat";
      $launcherText.style.display = isOpen ? "none" : "inline-flex";
    }
    btn.setAttribute("aria-expanded", isOpen ? "true" : "false");
  }

  function linkify(t) {
    return t.replace(/\bhttps?:\/\/[^\s<]+/g, (url) =>
      `<a href="${url}" target="_blank" rel="noopener noreferrer">Click here to book a meeting</a>`
    );
  }
  function withBreaks(t) { return t.replace(/\n/g, "<br>"); }
  function setBoxView(w)  { box.setAttribute("data-view", w); }

  function setActiveTab(which) {
    $viewHome.classList.toggle("active", which === "home");
    $viewMsgs.classList.toggle("active", which === "messages");
    setBoxView(which);
    $tabs.forEach((t) => t.classList.toggle("active", t.getAttribute("data-tab") === which));
    if (which === "messages") setTimeout(() => $input && $input.focus(), 0);
  }

  function handoffKey() {
    return conversationId ? `cf_chat_handoff_shown_${conversationId}` : "";
  }

  function pinTypingToBottom() {
    if (!typingEl || typingEl.parentNode !== $msgs) return;
    $msgs.appendChild(typingEl);
    $msgs.scrollTop = $msgs.scrollHeight;
  }

  function showTyping() {
    if (typingEl) return;
    typingEl = document.createElement("div");
    typingEl.className = "cfBubble admin typing";
    typingEl.setAttribute("data-typing", "1");
    typingEl.innerHTML = `<div class="cfTypingDots" aria-label="Admin typing"><span></span><span></span><span></span></div>`;
    $msgs.appendChild(typingEl);
    $msgs.scrollTop = $msgs.scrollHeight;
  }

  function hideTyping() {
    if (!typingEl) return;
    typingEl.remove();
    typingEl = null;
  }

  // ─── CONTACT CAPTURE FORM ────────────────────────────────────────────────
  function showContactCaptureForm() {
    if (contactCaptureShown || contactCaptured) return;
    contactCaptureShown = true;
    hideTyping();

    const formEl = document.createElement("div");
    formEl.className = "cfContactCapture";
    formEl.innerHTML = `
      <div class="cfContactCapture__msg">Before I connect you with our team, can I grab your details? 👇</div>
      <div class="cfContactCapture__fields">
        <input class="cfContactCapture__input" type="text" placeholder="Your name" data-capture-name autocomplete="name" />
        <input class="cfContactCapture__input" type="email" placeholder="Your email address" data-capture-email autocomplete="email" />
        <input class="cfContactCapture__input" type="tel" placeholder="Your phone number" data-capture-phone autocomplete="tel" />
        <button class="cfContactCapture__btn" type="button" data-capture-submit>Continue →</button>
      </div>
      <div class="cfContactCapture__error" data-capture-error></div>
    `;

    $msgs.appendChild(formEl);
    $msgs.scrollTop = $msgs.scrollHeight;

    const $n   = formEl.querySelector("[data-capture-name]");
    const $e   = formEl.querySelector("[data-capture-email]");
    const $p   = formEl.querySelector("[data-capture-phone]");
    const $btn = formEl.querySelector("[data-capture-submit]");
    const $err = formEl.querySelector("[data-capture-error]");

    setTimeout(() => $n.focus(), 100);

    const submit = () => handleContactSubmit($n, $e, $p, $btn, $err, formEl);
    $btn.addEventListener("click", submit);
    [$n, $e, $p].forEach(i => i.addEventListener("keydown", (e) => { if (e.key === "Enter") submit(); }));
  }

  async function handleContactSubmit($n, $e, $p, $btn, $err, formEl) {
    const name  = ($n.value || "").trim();
    const email = ($e.value || "").trim();
    const phone = ($p.value || "").trim();

    if (!name)  { $err.textContent = "Please enter your name."; return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { $err.textContent = "Please enter a valid email."; return; }
    if (!phone) { $err.textContent = "Please enter your phone number."; return; }

    $err.textContent = "";
    $btn.disabled = true;
    $btn.textContent = "Saving...";

    customerName  = name;
    customerEmail = email;
    customerPhone = phone;
    localStorage.setItem("cf_chat_customer_name",     name);
    localStorage.setItem("cf_chat_customer_email",    email);
    localStorage.setItem("cf_chat_customer_phone",    phone);
    localStorage.setItem("cf_chat_contact_captured",  "1");
    contactCaptured = true;

    formEl.remove();

    addMsg({
      id: "capture_confirm_" + Date.now(),
      role: "admin",
      text: `Thanks, ${name}! Our team will get back to you shortly. 🙌`,
      created_at: Date.now()
    });

    await Promise.allSettled([
      pushContactToGHL(name, email),
      updateConversationContact(name, email),
      sendEmailSummary(name, email)
    ]);

  }

  // ─── GHL PUSH ────────────────────────────────────────────────────────────
  async function pushContactToGHL(name, email) {
    try {
      const parts     = name.trim().split(" ");
      const firstName = parts[0] || "";
      const lastName  = parts.slice(1).join(" ") || "";

      const res = await fetch("https://services.leadconnectorhq.com/contacts/upsert", {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${GHL_API_KEY}`,
          "Content-Type":  "application/json",
          "Version":        "2021-07-28"
        },
        body: JSON.stringify({
          locationId: GHL_LOCATION_ID,
          firstName,
          lastName,
          email,
          phone: customerPhone || "",
          source: "Website Chat",
          tags:   ["website chat"]
        })
      });

      const data      = await res.json();
      const contactId = data?.contact?.id;
      if (!contactId) { console.warn("[Inkd Chat] GHL upsert issue:", data); return; }

      console.log("[Inkd Chat] GHL contact saved:", contactId);

      await fetch(`https://services.leadconnectorhq.com/contacts/${contactId}/notes`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${GHL_API_KEY}`,
          "Content-Type":  "application/json",
          "Version":        "2021-07-28"
        },
        body: JSON.stringify({
          body: `Website chat\nPage: ${location.href}\nConversation ID: ${conversationId}\nTime: ${new Date().toLocaleString()}`
        })
      });
    } catch (e) {
      console.warn("[Inkd Chat] GHL push error:", e);
    }
  }

  // ─── UPDATE CONVERSATION ─────────────────────────────────────────────────
  async function updateConversationContact(name, email) {
    if (!conversationId) return;
    try {
      await api("/api/update-contact", {
        method: "POST",
        body: JSON.stringify({ conversation_id: conversationId, customer_name: name, customer_email: email })
      });
    } catch (e) {
      console.warn("[Inkd Chat] update-contact error:", e);
    }
  }

  // ─── EMAIL SUMMARY ───────────────────────────────────────────────────────
  async function sendEmailSummary(name, email) {
    if (emailSummarySent) return;
    emailSummarySent = true;

    // Wait for EmailJS if still loading
    if (!emailJSReady) await loadEmailJS();

    if (!window.emailjs) {
      console.warn("[Inkd Chat] EmailJS unavailable, skipping summary.");
      return;
    }

    try {
      const transcript = conversationLog.length
        ? conversationLog.map(m => `[${m.role}] ${m.text}`).join("\n")
        : "(No messages captured)";

      const result = await window.emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          to_email:        SUMMARY_EMAIL,
          visitor_name:    name,
          visitor_email:   email,
          visitor_phone:   customerPhone || "N/A",
          chat_url:        location.href,
          conversation_id: conversationId || "N/A",
          transcript:      transcript,
          timestamp:       new Date().toLocaleString()
        }
      );
      console.log("[Inkd Chat] Email summary sent:", result.status, result.text);
    } catch (e) {
      console.warn("[Inkd Chat] Email summary error:", e);
    }
  }

  // ─── HANDOFF ─────────────────────────────────────────────────────────────
  function showHandoffDivider() {
    if (handoffShown) return;
    const k = handoffKey();
    if (k && localStorage.getItem(k) === "1") { handoffShown = true; return; }
    hideTyping();
    const el = document.createElement("div");
    el.className = "cfEvent cfEvent--handoff";
    el.setAttribute("data-event", "handoff");
    el.innerHTML =
      `<span class="cfEvent__line"></span>` +
      `<span class="cfEvent__text">You're connected — reply in ~5 min</span>` +
      `<span class="cfEvent__line"></span>`;
    $msgs.appendChild(el);
    $msgs.scrollTop = $msgs.scrollHeight;
    handoffShown = true;
    if (k) localStorage.setItem(k, "1");
  }

  function handleHandoffTrigger() {
    if (!contactCaptured) {
      showContactCaptureForm();
    } else {
      if (customerName && customerEmail && !emailSummarySent) {
        sendEmailSummary(customerName, customerEmail);
      }
    }
  }

  // Detect if bot message already contains an email address (your existing flow)
  function detectContactInMessage(text) {
    if (contactCaptured || emailSummarySent) return;
    const emailMatch = text.match(/[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}/);
    if (!emailMatch) return;

    const detectedEmail = emailMatch[0];

    // Try to extract phone number from bot message
    const phoneMatch = text.match(/[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}/);
    const detectedPhone = phoneMatch ? phoneMatch[0] : "";

    // Try to extract name — look for "name is X" or use stored name
    const nameMatch = text.match(/name is ([A-Z][a-z]+(?: [A-Z][a-z]+)*)/i);
    const detectedName = nameMatch
      ? nameMatch[1]
      : (localStorage.getItem("cf_chat_customer_name") || "Website Visitor");

    customerEmail = detectedEmail;
    customerName  = detectedName;
    customerPhone = detectedPhone;

    localStorage.setItem("cf_chat_customer_email",   detectedEmail);
    localStorage.setItem("cf_chat_customer_name",    detectedName);
    localStorage.setItem("cf_chat_customer_phone",   detectedPhone);
    localStorage.setItem("cf_chat_contact_captured", "1");
    contactCaptured = true;

    console.log("[Inkd Chat] Detected contact in bot message:", detectedEmail);

    // Show phone prompt then push to GHL
    showPhoneCaptureForm(detectedName, detectedEmail);
  }



  // ─── PHONE CAPTURE (after bot collects name+email) ───────────────────────
  function showPhoneCaptureForm(name, email) {
    const formEl = document.createElement("div");
    formEl.className = "cfContactCapture";
    formEl.innerHTML = `
      <div class="cfContactCapture__msg">One last thing — what's the best phone number to reach you? 📞</div>
      <div class="cfContactCapture__fields">
        <input class="cfContactCapture__input" type="tel" placeholder="Your phone number" data-phone-input autocomplete="tel" />
        <button class="cfContactCapture__btn" type="button" data-phone-submit>Submit →</button>
        <button class="cfContactCapture__skip" type="button" data-phone-skip>Skip</button>
      </div>
      <div class="cfContactCapture__error" data-phone-error></div>
    `;

    $msgs.appendChild(formEl);
    $msgs.scrollTop = $msgs.scrollHeight;

    const $ph  = formEl.querySelector("[data-phone-input]");
    const $btn = formEl.querySelector("[data-phone-submit]");
    const $skip = formEl.querySelector("[data-phone-skip]");
    const $err = formEl.querySelector("[data-phone-error]");

    setTimeout(() => $ph.focus(), 100);

    const submit = async () => {
      const phone = ($ph.value || "").trim();
      if (!phone) { $err.textContent = "Please enter a phone number or skip."; return; }
      $btn.disabled = true;
      $btn.textContent = "Saving...";
      customerPhone = phone;
      localStorage.setItem("cf_chat_customer_phone", phone);
      formEl.remove();
      await Promise.allSettled([
        pushContactToGHL(name, email),
        sendEmailSummary(name, email)
      ]);
    };

    const skip = async () => {
      formEl.remove();
      await Promise.allSettled([
        pushContactToGHL(name, email),
        sendEmailSummary(name, email)
      ]);
    };

    $btn.addEventListener("click", submit);
    $skip.addEventListener("click", skip);
    $ph.addEventListener("keydown", (e) => { if (e.key === "Enter") submit(); });
  }

  // ─── MESSAGES ────────────────────────────────────────────────────────────
  function msgKey(m) {
    const id = m && (m.id || m.message_id || m.uuid);
    return id ? `id:${id}` : `k:${(m.role||"").toLowerCase()}|${Number(m.created_at||0)}|${m.text||""}`;
  }

  function addMsg(m) {
    const role = (m.role || "").toLowerCase();
    const text = m.text || "";
    if (role === "system") return;

    const key = msgKey(m);
    if (seenMsgKeys.has(key)) return;
    seenMsgKeys.add(key);

    if (role === "customer" || role === "admin") {
      conversationLog.push({
        role: role === "customer" ? "Customer" : "Staff",
        text,
        time: fmt(m.created_at || Date.now())
      });
    }

    if (role === "admin") {
      hideTyping();
      detectContactInMessage(text);
    }

    if (role === "customer" && text) {
      const locals = $msgs.querySelectorAll('.cfBubble.customer[data-local="1"]');
      for (const b of locals) {
        if ((b.getAttribute("data-text") || "") === text) { b.remove(); break; }
      }
    }

    const div = document.createElement("div");
    div.className = "cfBubble " + (role === "customer" ? "customer" : "admin");
    const displayName = role === "customer" ? "You" : (m?.metadata?.staff_name || "Staff");
    const richText    = linkify(withBreaks(esc(text)));

    if (role === "customer" && m.metadata && m.metadata.local) {
      div.setAttribute("data-local", "1");
      div.setAttribute("data-text", text);
    }

    div.innerHTML =
      `<div class="cfMeta">${esc(displayName)} • ${fmt(m.created_at || Date.now())}</div>` +
      `<div>${richText}</div>`;

    $msgs.appendChild(div);
    $msgs.scrollTop = $msgs.scrollHeight;
    pinTypingToBottom();

    if (pendingHandoffDivider && role === "admin") {
      pendingHandoffDivider = false;
      handleHandoffTrigger();
    }
  }

  function resetMsgs() {
    $msgs.innerHTML  = "";
    lastSince        = 0;
    loadedHistory    = false;
    handoffShown     = false;
    emailSummarySent = false;
    seenMsgKeys.clear();
    conversationLog  = [];
  }

  // ─── API ─────────────────────────────────────────────────────────────────
  async function api(path, opts) {
    const res = await fetch(WORKER_BASE + path, {
      ...opts,
      headers: { "content-type": "application/json", ...(opts?.headers || {}) }
    });
    return res.json();
  }

  async function startIfNeeded() {
    if (conversationId) return;
    const out = await api("/api/start", {
      method: "POST",
      body: JSON.stringify({
        shop_domain:    location.hostname,
        customer_email: customerEmail || "",
        customer_name:  customerName  || "",
        metadata:       { url: location.href, ua: navigator.userAgent }
      })
    });
    if (!out.ok) { console.warn("chat start failed", out); return; }
    conversationId = out.conversation_id;
    localStorage.setItem("cf_chat_conversation_id", conversationId);
    handoffShown = localStorage.getItem(`cf_chat_handoff_shown_${conversationId}`) === "1";
  }

  async function loadHistoryOnce() {
    if (!conversationId || loadedHistory) return;
    const out = await api(`/api/messages?conversation_id=${encodeURIComponent(conversationId)}&since=0`, { method: "GET" });
    if (!out.ok) return;
    resetMsgs();
    (out.messages || []).forEach(addMsg);
    const msgs = out.messages || [];
    lastSince     = msgs.length ? Number(msgs[msgs.length - 1].created_at || 0) : 0;
    loadedHistory = true;
  }

  function connectWS() {
    if (!conversationId) return;
    try {
      const wsBase = WORKER_BASE.replace("https://", "wss://").replace("http://", "ws://");
      ws = new WebSocket(
        `${wsBase}/ws?conversation_id=${encodeURIComponent(conversationId)}&role=customer&name=${encodeURIComponent(customerName || "Customer")}`
      );
      ws.onopen    = () => { if (pollTimer) { clearInterval(pollTimer); pollTimer = null; } };
      ws.onmessage = (ev) => {
        try {
          const data = JSON.parse(ev.data);
          if (data.type === "message" && data.message) {
            addMsg(data.message);
            lastSince = Math.max(lastSince, Number(data.message.created_at || 0));
          }
          if (data.type === "status" && data.status?.type === "ui_event" && data.status?.event === "handoff") {
            pendingHandoffDivider = true;
            handleHandoffTrigger();
          }
        } catch (e) { console.warn("ws parse failed", e); }
      };
      ws.onclose = () => { ws = null; startPolling(); };
      ws.onerror = () => { ws = null; startPolling(); };
    } catch (e) { ws = null; startPolling(); }
  }

  function startPolling() {
    if (pollTimer) return;
    pollTimer = setInterval(async () => {
      if (!conversationId) return;
      const out = await api(`/api/messages?conversation_id=${encodeURIComponent(conversationId)}&since=${lastSince}`, { method: "GET" });
      if (!out.ok) return;
      const msgs = out.messages || [];
      msgs.forEach(addMsg);
      if (msgs.length) lastSince = Math.max(lastSince, Number(msgs[msgs.length - 1].created_at || 0));
    }, 1500);
  }

  async function ensureLive() {
    await startIfNeeded();
    await loadHistoryOnce();
    if (!loadedHistory) await loadHistoryOnce();
    connectWS();
    startPolling();
  }

  // ─── OPEN / CLOSE ────────────────────────────────────────────────────────
  function openChat() {
    box.classList.add("is-open");
    box.setAttribute("aria-hidden", "false");
    setActiveTab("home");
    syncLauncherState();
  }

  function closeChat() {
    box.classList.remove("is-open");
    box.setAttribute("aria-hidden", "true");
    closeEmojiPop();
    syncLauncherState();
  }

  // ─── COMPOSER ────────────────────────────────────────────────────────────
  function syncSendState() {
    const has = ($input.value || "").trim().length > 0;
    $send.disabled = !has;
    $send.classList.toggle("is-ready", has);
  }

  function addLocalCustomerMsg(text) {
    addMsg({
      id: "local_" + Date.now() + "_" + Math.random().toString(16).slice(2),
      role: "customer", text, created_at: Date.now(), metadata: { local: true }
    });
  }

  async function sendMsg() {
    const t = ($input.value || "").trim();
    if (!t) return;
    $input.value = "";
    syncSendState();
    addLocalCustomerMsg(t);
    showTyping();
    const timeout = setTimeout(() => hideTyping(), 25000);
    try {
      await startIfNeeded();
      const out = await api("/api/message", {
        method: "POST",
        body: JSON.stringify({ conversation_id: conversationId, role: "customer", text: t, metadata: { page: location.href } })
      });
      if (!out.ok) { clearTimeout(timeout); hideTyping(); return; }
      if (!ws || ws.readyState !== WebSocket.OPEN) {
        addMsg(out.message);
        lastSince = Math.max(lastSince, Number(out.message.created_at || 0));
      }
    } catch (e) { clearTimeout(timeout); hideTyping(); }
  }

  // ─── EMOJI ───────────────────────────────────────────────────────────────
  function insertAtCursor(input, text) {
    const s = input.selectionStart ?? input.value.length;
    const e = input.selectionEnd   ?? input.value.length;
    input.value = input.value.slice(0, s) + text + input.value.slice(e);
    input.setSelectionRange(s + text.length, s + text.length);
    input.focus();
    syncSendState();
  }

  function closeEmojiPop() { if (!emojiPop) return; emojiPop.remove(); emojiPop = null; }

  function openEmojiPop(anchorBtn) {
    closeEmojiPop();
    emojiPop = document.createElement("div");
    emojiPop.className = "cfEmojiPop";
    emojiPop.setAttribute("role", "dialog");
    emojiPop.innerHTML = `<div class="cfEmojiGrid">${EMOJIS.map(e => `<button type="button" class="cfEmojiBtn" data-e="${e}">${e}</button>`).join("")}</div>`;
    box.appendChild(emojiPop);
    const a = anchorBtn.getBoundingClientRect(), b = box.getBoundingClientRect();
    emojiPop.style.left = `${Math.max(10, a.left - b.left - 6)}px`;
    emojiPop.style.top  = `${Math.max(10, (a.top - b.top) - 10 - emojiPop.offsetHeight)}px`;
    emojiPop.addEventListener("click", (ev) => {
      const t = ev.target.closest("[data-e]");
      if (!t) return;
      insertAtCursor($input, t.getAttribute("data-e") || "");
      closeEmojiPop();
    });
    setTimeout(() => {
      function onDocDown(e) {
        if (!emojiPop) { document.removeEventListener("mousedown", onDocDown, { capture: true }); return; }
        if (emojiPop.contains(e.target) || anchorBtn.contains(e.target)) return;
        closeEmojiPop();
        document.removeEventListener("mousedown", onDocDown, { capture: true });
      }
      document.addEventListener("mousedown", onDocDown, { capture: true });
    }, 0);
  }

  // ─── VOICE ───────────────────────────────────────────────────────────────
  function setVoiceUI(recording) {
    isRecording = recording;
    $voice.classList.toggle("is-recording", recording);
    $voice.setAttribute("aria-pressed", recording ? "true" : "false");
  }

  function initSpeech() {
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) return null;
    const r = new SR();
    r.lang = "en-US"; r.interimResults = true; r.continuous = true;
    r.onresult = (ev) => {
      let t = "";
      for (let i = ev.resultIndex; i < ev.results.length; i++) t += ev.results[i][0].transcript;
      const cur = ($input.value || "").trim();
      $input.value = (cur ? cur + " " : "") + t.trim();
      syncSendState();
    };
    r.onend = () => setVoiceUI(false);
    r.onerror = () => setVoiceUI(false);
    return r;
  }

  async function toggleVoice() {
    if (!rec) rec = initSpeech();
    if (!rec) { addMsg({ role: "system", text: "Voice input isn't supported in this browser.", created_at: Date.now() }); return; }
    if (!isRecording) { try { closeEmojiPop(); $input.focus(); rec.start(); setVoiceUI(true); } catch(e){} }
    else { try { rec.stop(); } catch(e){} setVoiceUI(false); }
  }

  // ─── EVENTS ──────────────────────────────────────────────────────────────
  btn.addEventListener("click", () => box.classList.contains("is-open") ? closeChat() : openChat());
  $close.addEventListener("click", closeChat);
  $back.addEventListener("click",  () => setActiveTab("home"));
  $send.addEventListener("click",  sendMsg);
  $input.addEventListener("input", syncSendState);
  $input.addEventListener("keydown", (e) => { if (e.key === "Enter") sendMsg(); });
  $emoji.addEventListener("click", () => emojiPop ? closeEmojiPop() : openEmojiPop($emoji));
  $voice.addEventListener("click", toggleVoice);
  $askCard.addEventListener("click", async () => { setActiveTab("messages"); await ensureLive(); });
  $meetingCard.addEventListener("click", () => window.open(MEETING_URL, "_blank", "noopener,noreferrer"));
  $tabs.forEach((t) => t.addEventListener("click", async () => {
    const to = t.getAttribute("data-tab");
    setActiveTab(to);
    if (to === "messages") await ensureLive();
  }));

  syncSendState();
  syncLauncherState();

  const params = new URLSearchParams(window.location.search);
  if (params.get(AUTO_OPEN_PARAM) === AUTO_OPEN_VALUE) setTimeout(() => openChat(), 400);

  // ─── STYLES ──────────────────────────────────────────────────────────────
  const style = document.createElement("style");
  style.textContent = `
    .cfContactCapture {
      background: #f0f9ff;
      border: 1px solid #bae6fd;
      border-radius: 12px;
      padding: 14px 16px;
      margin: 8px 0;
      max-width: 92%;
    }
    .cfContactCapture__msg {
      font-size: 13px;
      color: #0c4a6e;
      margin-bottom: 10px;
      line-height: 1.5;
    }
    .cfContactCapture__fields {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
    .cfContactCapture__input {
      width: 100%;
      padding: 8px 12px;
      border: 1px solid #7dd3fc;
      border-radius: 8px;
      font-size: 13px;
      outline: none;
      background: #fff;
      box-sizing: border-box;
      transition: border-color 0.2s, box-shadow 0.2s;
      font-family: inherit;
    }
    .cfContactCapture__input:focus {
      border-color: #0ea5e9;
      box-shadow: 0 0 0 3px rgba(14,165,233,0.15);
    }
    .cfContactCapture__btn {
      background: #0ea5e9;
      color: #fff;
      border: none;
      border-radius: 8px;
      padding: 10px 14px;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      transition: background 0.2s;
      font-family: inherit;
    }
    .cfContactCapture__btn:hover:not(:disabled) { background: #0284c7; }
    .cfContactCapture__btn:disabled { opacity: 0.6; cursor: not-allowed; }
    .cfContactCapture__error {
      color: #dc2626;
      font-size: 12px;
      margin-top: 4px;
      min-height: 16px;
    }
    .cfContactCapture__skip {
      background: transparent;
      color: #64748b;
      border: none;
      font-size: 12px;
      cursor: pointer;
      text-align: center;
      padding: 4px;
      text-decoration: underline;
      font-family: inherit;
    }
    .cfContactCapture__skip:hover { color: #334155; }
  `;
  document.head.appendChild(style);

})();
